// imports
import Vue from 'vue'
import Router from 'vue-router'

// guards
import { globalAuthGuard } from './guards'

// modules
import legacyRoutes from './modules/legacy'
import systemRoutes from './modules/system'
import adminRoutes from './modules/admin'
import applicantRoutes from './modules/applicant'
import positionRoutes from './modules/position'
import companyRoutes from './modules/company'

Vue.use(Router)

export const routes = [
  ...legacyRoutes,
  ...systemRoutes,
  ...adminRoutes,
  ...applicantRoutes,
  ...positionRoutes,
  ...companyRoutes
]

const router = new Router({
  routes,
  mode: 'history',
  base: process.env.BASE_URL
})

// Apply the Global Route Guard
router.beforeEach(globalAuthGuard)

export default router
